import React, { useState } from "react"
import { Link } from "react-router-dom"
import { price } from "../../data/Data"
import { API_BASE } from "../../../lib/api"
import "./price.css"

const PriceCard = () => {
  const [modalPlan, setModalPlan] = useState(null)
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", message: "" })
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState("")

  const openQuoteModal = (plan) => {
    if (plan === "Build Consultation" || plan === "Design & Build") {
      setModalPlan(plan)
      setFormData({ name: "", email: "", phone: "", message: "" })
      setSuccess(false)
      setError("")
    }
  }

  const closeModal = () => {
    setModalPlan(null)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleQuoteSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setLoading(true)
    try {
      const res = await fetch(`${API_BASE}/api/quote-requests`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: modalPlan,
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
        }),
      })
      const data = await res.json()
      if (!res.ok) {
        setError(data.error || "Something went wrong")
        return
      }
      setSuccess(true)
    } catch (err) {
      setError("Could not send. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className='content flex mtop'>
        {price.map((item, index) => (
          <div className='box shadow' key={index}>
            <div className='topbtn'>
              <button className='btn3'>{item.best}</button>
            </div>
            <h3>{item.plan}</h3>
            <h1>
              {item.price !== "Free" && item.price !== "Quote" ? <span>$</span> : null}
              {item.price}
            </h1>
            <p>{item.ptext}</p>

            <ul>
              {item.list.map((val, i) => {
                const { icon, text, change } = val
                return (
                  <li key={i}>
                    <label
                      style={{
                        background: change === "color" ? "#dc35451f" : "#27ae601f",
                        color: change === "color" ? "#dc3848" : "#27ae60",
                      }}
                    >
                      {icon}
                    </label>
                    <p>{text}</p>
                  </li>
                )
              })}
            </ul>
            {item.plan === "Property Search" ? (
              <Link to='/listings'>
                <button className='btn5'>Browse Listings</button>
              </Link>
            ) : item.plan === "Build Consultation" || item.plan === "Design & Build" ? (
              <button
                type='button'
                className='btn5'
                style={{
                  background: item.plan === "Build Consultation" ? "#27ae60" : "#fff",
                  color: item.plan === "Build Consultation" ? "#fff" : "#27ae60",
                }}
                onClick={() => openQuoteModal(item.plan)}
              >
                Get a Quote
              </button>
            ) : (
              <button className='btn5'>Start {item.plan}</button>
            )}
          </div>
        ))}
      </div>

      {modalPlan && (
        <div className='quote-modal-overlay' onClick={closeModal} aria-hidden='true'>
          <div className='quote-modal' onClick={(e) => e.stopPropagation()}>
            <div className='quote-modal__header'>
              <h3>Request a quote — {modalPlan}</h3>
              <button type='button' className='quote-modal__close' onClick={closeModal} aria-label='Close'>
                &times;
              </button>
            </div>
            {success ? (
              <div className='quote-modal__success'>
                <p>Thanks! We&apos;ve received your request and will get back to you soon.</p>
                <button type='button' className='btn5' onClick={closeModal}>Close</button>
              </div>
            ) : (
              <form onSubmit={handleQuoteSubmit} className='quote-modal__form'>
                {error && <p className='quote-modal__error'>{error}</p>}
                <label htmlFor='quote-name'>Name *</label>
                <input id='quote-name' name='name' value={formData.name} onChange={handleChange} required />
                <label htmlFor='quote-email'>Email *</label>
                <input id='quote-email' name='email' type='email' value={formData.email} onChange={handleChange} required />
                <label htmlFor='quote-phone'>Phone</label>
                <input id='quote-phone' name='phone' type='tel' value={formData.phone} onChange={handleChange} />
                <label htmlFor='quote-message'>Message</label>
                <textarea id='quote-message' name='message' value={formData.message} onChange={handleChange} rows={4} />
                <div className='quote-modal__actions'>
                  <button type='button' className='btn5' style={{ background: "#666" }} onClick={closeModal}>Cancel</button>
                  <button type='submit' className='btn5' disabled={loading}>{loading ? "Sending…" : "Submit"}</button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default PriceCard
